var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":"required"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('Select',{attrs:{"value":_vm.selectedOption,"label":"","item-text":"label","item-value":"value","items":_vm.questionOptions,"error-messages":_vm.showValidationErrors ? errors : [],"autocomplete":""},on:{"change":_vm.handleChange}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }